var _path, _path2, _path3, _path4, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.12208 18.4029L10.4538 17.0999H18.0537C18.3453 17.0938 19.0391 16.9882 19.0391 16.1355C19.0391 15.2183 18.2183 15.1718 18.0537 15.1718L12.7532 15.13L6.68409 12.9683H0.46875V11.5908L7.04814 11.6323L13.1169 13.7944H18.0537C19.0145 13.7944 20.445 14.418 20.445 16.1355C20.445 17.8537 19.0145 18.4773 18.0537 18.4773H11.0361L10.1162 19.3775L9.12208 18.4029Z",
    fill: "#A31265"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.878906 20.7244L0.884508 19.209L10.835 24.2688C16.068 21.6653 23.7622 17.8163 24.2895 17.4891C24.5054 17.3554 24.6567 17.1427 24.7175 16.8899C24.7775 16.6395 24.7383 16.3825 24.6088 16.1655C24.4783 15.9457 24.2718 15.7907 24.0257 15.7298C23.7799 15.6649 23.5258 15.7056 23.3116 15.8397L18.8944 18.2069V16.9661L22.6125 14.6615C23.1349 14.3381 23.7504 14.2428 24.3464 14.392C24.9428 14.5406 25.4454 14.9164 25.7617 15.4507C26.0779 15.9804 26.1727 16.608 26.0276 17.2157C25.8821 17.8262 25.5135 18.3407 24.99 18.6658C24.2253 19.1406 12.4648 24.99 11.1266 25.6555L10.8284 25.8033L0.878906 20.7244Z",
    fill: "#A31265"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4369 15.6081L19.2059 15.5258C19.2158 15.3593 19.2202 15.1912 19.2202 15.0225C19.2202 10.2966 15.5588 6.4516 11.0581 6.4516C7.43511 6.4516 4.20944 9.00263 3.21287 12.6552L2.02734 12.2987C3.17381 8.09314 6.8876 5.15625 11.0581 5.15625C16.2391 5.15625 20.4537 9.58227 20.4537 15.0225C20.4537 15.2193 20.4486 15.414 20.4369 15.6081Z",
    fill: "#A31265"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9179 4.79532C13.7242 5.1068 15.2713 5.5885 16.7774 5.40733C17.1308 5.36481 17.4662 5.28658 17.7732 5.17594C19.548 4.53536 20.6058 2.75871 21.041 1.8622C20.2355 1.55064 18.6872 1.06873 17.1812 1.2499C16.8278 1.29242 16.4927 1.37061 16.1842 1.48143C14.4087 2.12244 13.3523 3.89856 12.9179 4.79532ZM16.8897 6.75104C14.3875 7.05206 11.9507 5.78174 11.8486 5.72769L11.3594 5.46848L11.5308 4.96311C11.5794 4.81949 12.7581 1.42696 15.6391 0.352404C16.039 0.203606 16.4704 0.100339 16.9211 0.0461232C19.4244 -0.25502 21.8611 1.01496 21.9632 1.06935L22.4524 1.32822L22.2811 1.83427C22.2322 1.9786 21.0505 5.37047 18.1709 6.44418C17.7718 6.59323 17.3407 6.69678 16.8897 6.75104Z",
    fill: "#A31265"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 10.1309,
    width: 1.35773,
    height: 12.3522,
    fill: "#A31265"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.b6fa4de1b6a92e98ec0e49cc5b8329d2.svg";
export { ForwardRef as ReactComponent };